import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { StudentDto } from 'stores/students/student-model';
import { IdentityService } from 'services/identity-service';
import { resolve } from 'inversify-react';
import TailwindStudentList from 'widgets/items-list/students-list-tw';
import TailwindChooseStudentsView from 'widgets/form/choose-students-form-tw';
import './students-assign-component.less';
import { EventFormStore } from 'stores/events/event-form-store';
import { connect } from 'redux-scaffolding-ts';
import { EventStatus } from 'stores/events/events-store';
import { StudentsTabViewModel } from './students-assign-component';

interface TailwindStudentsAssignTableComponentProps extends WithTranslation {
  readOnly: boolean;
  value: StudentsTabViewModel;
  onChange?: (value: StudentsTabViewModel) => void;
  className?: string;
  eventFormStore?: EventFormStore;
  cameFrom: 'Event' | 'Request';
}

export interface TailwindStudentsAssignTableComponentState {
  isOpenedUsersModal: boolean;
}

@connect(['eventFormStore', EventFormStore])
class TailwindStudentsAssignTableComponent extends Component<
  TailwindStudentsAssignTableComponentProps,
  TailwindStudentsAssignTableComponentState
> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  state: TailwindStudentsAssignTableComponentState = {
    isOpenedUsersModal: false
  };

  private handleOnOpenUserModal = () => {
    this.setState({ isOpenedUsersModal: true });
  };

  private handleOnCloseUserModal = () => {
    this.setState({ isOpenedUsersModal: false });
  };

  private handleOnAssignedStudentsNumber = (studentsNumber: string) => {
    const value = { ...this.props.value };
    value.studentsAssigned = studentsNumber === '' ? null : +studentsNumber;
    this.props.onChange?.(value);
  };

  private handleOnAddParticipants = (newStudents: StudentDto[]) => {
    let newValue = { ...this.props.value };
    newValue.students = [...newValue.students, ...newStudents];
    newValue.studentsAssigned = newValue.studentsAssigned > newValue.students.length ? newValue.studentsAssigned : newValue.students.length;

    this.props.onChange && this.props.onChange(newValue);
  };

  private handleOnRemoveStudent = (student: StudentDto) => {
    let value = { ...this.props.value };
    value.students = value.students.filter(x => student.id !== x.id);
    value.studentsAssigned = value.students.length === 0 ? value.studentsAssigned - value.students.length : value.studentsAssigned;

    this.props.onChange && this.props.onChange(value);
  };

  render() {
    const { t, readOnly, cameFrom } = this.props;
    const { isOpenedUsersModal } = this.state;
    const { studentsRequested, studentsAssigned, studentsOptional } = this.props.value;
    const students = this.props.value.students;
    const locationIds =
      this.identityService.activeRole === 'PoC' ? (this.identityService.getUserInfo().locationsByRoles['PoC'] as string[]) : null;
    const studentsMandatory =
      !studentsOptional &&
      cameFrom === 'Event' &&
      this.props.eventFormStore?.state?.item?.status !== undefined &&
      Number(EventStatus[this.props.eventFormStore?.state?.item?.status]) >= Number(EventStatus.InProgress);

    return (
      <>
        <div className="p-4">
          {!!studentsRequested && (
            <div className="mb-3">
              <label className="block text-sm text-gray-700 mb-1">{t('Students Requested')}</label>
              <input
                className="w-full p-2 border border-gray-300 rounded"
                disabled={readOnly}
                value={studentsRequested}
                placeholder={t('Students Requested')}
                type="text"
              />
            </div>
          )}

          <div className="mb-3">
            <label className="block text-sm text-gray-700 mb-1">{t('Students Assigned')}</label>
            <input
              className="w-full p-2 border border-gray-300 rounded"
              placeholder={t('Students Assigned')}
              type="text"
              value={studentsAssigned != null && !Number.isNaN(studentsAssigned) ? studentsAssigned : ''}
              disabled={readOnly}
              onChange={e => {
                const value = e.target.value;
                if (value === '' || !isNaN(Number(value))) {
                  this.handleOnAssignedStudentsNumber(value);
                }
              }}
              required={studentsMandatory}
            />
          </div>
          <button
            className={`w-full ${readOnly ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
            disabled={readOnly}
            onClick={this.handleOnOpenUserModal}
          >
            Assign Students
          </button>
        </div>

        {students && students.length > 0 && (
          <TailwindStudentList
            canRemove={!readOnly}
            students={students}
            onStudentRemove={this.handleOnRemoveStudent}
            pocLocations={locationIds}
          />
        )}

        {isOpenedUsersModal && (
          <TailwindChooseStudentsView
            locationIds={locationIds}
            alreadySelectedUserIds={students && students.map(x => x.id)}
            students={students}
            onAddParticipants={this.handleOnAddParticipants}
            onCloseUsersModal={this.handleOnCloseUserModal}
          />
        )}
      </>
    );
  }
}

export default withTranslation()(TailwindStudentsAssignTableComponent);
